export function iconFromType(type: string) {
  switch (type) {
    case "INFORMATION":
      return "info";
    case "REVIEW":
      return "inventory";
    case "ALERT":
      return "flag";
  }
  return "info";
}
export function iconColorFromType(type: string) {
  switch (type) {
    case "INFORMATION":
      return "blue";
    case "REVIEW":
      return "purple";
    case "ALERT":
      return "orange";
  }
  return "blue";
}
